(function ($, document, window) {
	'use strict';

	function checkIfNavNeeded(lockOrUnlock, sliderElement, nav, bottomNav) {
		if ('lock' === lockOrUnlock) {
			nav.addClass('featured-posts__carousel-nav--hidden');
			bottomNav.addClass('featured-posts__nav--hidden');

			sliderElement.removeAttribute('role');
			sliderElement.removeAttribute('aria-label');
			sliderElement.removeAttribute('aria-roledescription');
		} else if ('unlock' === lockOrUnlock) {
			nav.removeClass('featured-posts__carousel-nav--hidden');
			bottomNav.removeClass('featured-posts__nav--hidden');

			sliderElement.setAttribute('role', 'region');
			sliderElement.setAttribute('aria-label', 'Posts Carousel');
			sliderElement.setAttribute('aria-roledescription', 'carousel');
		}
	}

	$(function () {
		$('.js-featured-carousel').each(function () {
			const sliderContainer = $(this);
			const sliderEl = $('.swiper', sliderContainer)[0];
			const navsContainer = $('.js-featured-carousel-nav', sliderContainer);
			const paginationEl = $('.js-featured-carousel-pagination', sliderContainer)[0];
			const bottomNav = $('.js-featured-carousel-navs', sliderContainer);

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 28,
				slidesPerView: 'auto',
				loop: false,
				navigation: false,
				watchOverflow: true,

				pagination: {
					el: paginationEl,
					type: 'bullets',
					clickable: true,
					bulletClass: 'featured-posts__pagination-bullet pagination-bullet',
					bulletActiveClass: 'pagination-bullet--active'
				},

				breakpoints: {
					744: {
						slidesPerView: 'auto',
					},

					1280: {
						slidesPerView: 4,
						spaceBetween: 40,
					},

					1440: {
						slidesPerView: 5,
						spaceBetween: 40,
					},

					1600: {
						slidesPerView: 5,
						spaceBetween: 64,
					},

					1896: {
						slidesPerView: 6,
						spaceBetween: 64,
					},
				},

				on: {
					lock: function () {
						checkIfNavNeeded('lock', sliderEl, navsContainer, bottomNav);
					},

					unlock: function () {
						checkIfNavNeeded('unlock', sliderEl, navsContainer, bottomNav);
					},

					slideChange: function () {
						if (this.isBeginning) {
							$('.js-carousel-nav-prev', sliderContainer).addClass('carousel-nav__button--disabled');
							$('.js-carousel-nav-prev', sliderContainer).attr('disabled', 'disabled');
						} else {
							$('.js-carousel-nav-prev', sliderContainer).removeClass('carousel-nav__button--disabled');
							$('.js-carousel-nav-prev', sliderContainer).removeAttr('disabled');
						}

						if (this.isEnd) {
							$('.js-carousel-nav-next', sliderContainer).addClass('carousel-nav__button--disabled');
							$('.js-carousel-nav-next', sliderContainer).attr('disabled', 'disabled');
						} else {
							$('.js-carousel-nav-next', sliderContainer).removeClass('carousel-nav__button--disabled');
							$('.js-carousel-nav-next', sliderContainer).removeAttr('disabled');
						}
					},
				},
			});

			$('.js-carousel-nav-next', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slideNext();
				});
			});

			$('.js-carousel-nav-prev', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slidePrev();
				});
			});
		});
	});
})(jQuery, document, window);
